import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f6a9c58"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Edit Corporate AI Configuration", -1))
const _hoisted_2 = { class: "editor-container" }
const _hoisted_3 = { class: "json-editor" }
const _hoisted_4 = { class: "visualization" }
const _hoisted_5 = {
  id: "network",
  ref: "networkContainer",
  style: {"width":"100%","height":"400px"}
}
const _hoisted_6 = { class: "generate-section" }
const _hoisted_7 = { class: "generate-options" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "modal-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal-overlay",
    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
  }, [
    _createElementVNode("div", {
      class: "modal-content",
      onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
    }, [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.corporateAIJson) = $event)),
            rows: "25",
            cols: "60"
          }, null, 512), [
            [_vModelText, _ctx.corporateAIJson]
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, null, 512)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.generatePrompt) = $event)),
          placeholder: "Enter prompt for new corp generation",
          class: "generate-input",
          rows: "3"
        }, null, 512), [
          [_vModelText, _ctx.generatePrompt]
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("label", null, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.baseOnCurrent) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.baseOnCurrent]
            ]),
            _createTextVNode(" Base new corp on current one ")
          ]),
          _createElementVNode("button", {
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.generateNewCorp && _ctx.generateNewCorp(...args))),
            class: "generate-button",
            disabled: _ctx.isGenerating
          }, [
            (!_ctx.isGenerating)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, "Generate New Corp"))
              : (_openBlock(), _createElementBlock("span", _hoisted_10, "Generating..."))
          ], 8, _hoisted_8)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("button", {
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.loadDefaultAI && _ctx.loadDefaultAI(...args)))
        }, "Load Defaults"),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.saveCorporateAI && _ctx.saveCorporateAI(...args)))
          }, "Save"),
          _createElementVNode("button", {
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
          }, "Cancel")
        ])
      ])
    ])
  ]))
}